import z from 'zod';
import { opportunityTransactions, } from './bid-requests';
export const DATE_RANGE_SEPARATOR = ' - ';
export const pricingDashboardQueryOptionsSchema = z.object({
    offset: z.number().optional(),
    limit: z.number().optional(),
    region: z.string().nullable().optional(),
    plant_type: z.string().nullable().optional(),
    transaction: z.enum(opportunityTransactions).nullable().optional(),
    status: z.enum(['All', 'Completed', 'Open']).nullable().optional(),
    project_id: z.string().nullable().optional(),
    search: z.string().nullable().optional(),
    sort_by: z.custom().nullable().optional(),
    sort_direction: z.enum(['asc', 'desc']).nullable().optional(),
    updated_at: z.string().nullable().optional(),
});
//# sourceMappingURL=pricing-dashboard.js.map